import { render } from "./IconChevron.vue?vue&type=template&id=0c8b592f&ts=true"
import script from "./IconChevron.vue?vue&type=script&lang=ts"
export * from "./IconChevron.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__